import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { UsersManagementApiService } from '../../../services/users-management-api.service';
import { VendorStaff } from '../../../models/VendorStaff';
import { ToastNotificationService } from '../../../../../notifications/services/toast-notification.service';
import { ToastNotificationType, ToastPosition } from '../../../../../notifications/models/toast-notification-type';
import { AuthService } from '../../../../auth/services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/translations/language.service';

@Component({
  selector: 'app-user-details-page',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './user-details-page.component.html',
  styleUrl: './user-details-page.component.css'
})
export class UserDetailsPageComponent implements OnInit {

  private route = inject(ActivatedRoute);
  private apiService = inject(UsersManagementApiService);
  private toast = inject(ToastNotificationService);
  private authService = inject(AuthService);
  private translate = inject(TranslateService);
  languageService = inject(LanguageService);

  userId: string | null = null;
  user: VendorStaff | null = null;
  loading = false;
  togglingActive = false;
  isOwner = this.authService.isOwner();
  currentUserId = this.authService.getTokenData()?.user_id;

  toggleActive(): void {
    if (!this.user || this.togglingActive) return;
    if (this.isCurrentUser(this.user.user.id)) {
        this.toast.createNotification(this.translate.instant('users_management.details.toggle_active.deny_self_message'), ToastNotificationType.ERROR, this.translate.instant('users_management.details.toggle_active.deny_self_title'), ToastPosition.TOP_RIGHT);
      return;
    }
    const next = !this.user.user.is_active;
    this.togglingActive = true;
    this.user.user.is_active = next;
    this.apiService.setVendorStaffActive(this.user.id, next).subscribe({
      next: () => {
        this.togglingActive = false;
        this.toast.createNotification(this.translate.instant('users_management.details.toggle_active.success_message'), ToastNotificationType.SUCCESS, this.translate.instant('users_management.details.toggle_active.success_title'), ToastPosition.TOP_RIGHT);
      },
      error: () => {
        if (this.user) this.user.user.is_active = !next;
        this.togglingActive = false;
        this.toast.createNotification(this.translate.instant('users_management.details.toggle_active.error_message'), ToastNotificationType.ERROR, this.translate.instant('users_management.details.toggle_active.error_title'), ToastPosition.TOP_RIGHT);
      }
    });
  }

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('id');
    if (!this.userId) return;

    this.loading = true;
    this.apiService.getVendorStaffById(this.userId).subscribe({
      next: (response) => {
        this.user = response;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toast.createNotification(this.translate.instant('users_management.details.errors.load_message'), ToastNotificationType.ERROR, this.translate.instant('users_management.details.errors.load_title'), ToastPosition.TOP_RIGHT);
      }
    });
  }

  isCurrentUser(id: number): boolean {
    return String(id) === String(this.currentUserId);
  }

}
